// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    SEARCH_PAGE_LOADING() {
      return {
        isLoading: true,
        searchPage: action.searchPage
      };
    },
    SEARCH_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const searchQuery = get(currentState, 'search.data.query.queryString');
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        searchQuery,
        'searchPage'
      );

      return {
        isLoading: false,
        data: action.searchPage,
        ads: adModelData
      };
    },
    SEARCH_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.searchPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
